import {
    CopyIcon,
    EnvelopeClosedIcon,
    UpdateIcon
} from '@radix-ui/react-icons';
import { useEffect, useState } from 'react';
import api from '../../lib/api';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import { DropdownMenuItem } from "../ui/dropdown-menu";
import { toast } from '../ui/use-toast';
import { Textarea } from '../ui/textarea';

const EmailCompetitionParticipantsDialog = ({ competitionId }) => {
    const [emailList, setEmailList] = useState('');
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const getEmailList = async () => {
            setIsLoading(true);
            const response = await api.get(`https://skhrf-api.cmdigital.se/v1/competitions/${competitionId}/emails`);
            setEmailList(response.data);
            setIsLoading(false);
        };

        if (isDialogOpen) {
            getEmailList();
        }
    }, [competitionId, isDialogOpen]);

    return (
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            <DropdownMenuItem onSelect={(event) => event.preventDefault()}>
                <DialogTrigger className='flex items-center w-full'>
                    <EnvelopeClosedIcon className='mr-3'/>
                    Hämta e-postlista över deltagare
                </DialogTrigger>
                <DialogContent className="flex flex-col gap-6" onOpenAutoFocus={(e) => e.preventDefault()}>
                    <DialogHeader className='text-left'>
                        <DialogTitle>Hämta e-postlista över deltagare</DialogTitle>
                        <DialogDescription>
                            Här kan du hämta en lista över e-postadresserna till deltagarna i tävlingen. Har deltagaren angivit en förälders e-postadress kommer den att inkluderas i listan.
                        </DialogDescription>
                    </DialogHeader>
                    <Textarea
                        disabled={isLoading}
                        readOnly={true}
                        value={emailList}
                    />
                    <div className='grid grid-cols-2 gap-3'>
                        <DialogClose asChild>
                            <Button type='button' variant='secondary'>Stäng</Button>
                        </DialogClose>
                        <Button
                            onClick={() => {
                                navigator.clipboard.writeText(emailList);
                                toast({
                                    title: 'E-postadresserna är kopierade',
                                    description: ''
                                });
                            }}
                            disabled={isLoading}
                        >
                            {isLoading ? <UpdateIcon className='loader-spinner' /> :
                                <>
                                    <CopyIcon className="size-4 mr-3" />
                                    Kopiera
                                </>
                            }
                        </Button>
                    </div>
                </DialogContent>
            </DropdownMenuItem>
        </Dialog>
    );
};

export default EmailCompetitionParticipantsDialog;
